import * as React from "react";
import { forwardRef } from "react";
const SvgChevronSmRight = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M6.171 13.896a1.16 1.16 0 0 1-.828-.35 1.2 1.2 0 0 1 0-1.68l3.858-3.918-3.858-3.92a1.2 1.2 0 0 1 0-1.68 1.16 1.16 0 0 1 1.656 0l4.68 4.762a1.2 1.2 0 0 1 0 1.68l-4.68 4.762a1.16 1.16 0 0 1-.828.344" }));
const ForwardRef = forwardRef(SvgChevronSmRight);
export { ForwardRef as ReactComponent };
